// src/plugins/axios.js
import axios from 'axios'

const httpApiHos = axios.create({
  // baseURL: 'http://localhost:8000/api',
  baseURL: 'https://api-hos.wanorn.com/backend/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    // 'Authorization': `Bearer ${token}` // ถ้ามี token
  }
})

export default httpApiHos
